export default "__VITE_PUBLIC_ASSET__4529b7f0__"